import React, { FC } from 'react';
import { RegularButton } from 'fronton-react';
import { useTranslation } from 'react-i18next';

export const DATA_QA_PRODUCT_SET_BUTTON = 'product-set-button';

type Props = {
  href: string;
};

export const ProductSetButton: FC<Props> = ({ href }) => {
  const { t } = useTranslation();
  const text = t('ui.product-set-button.button');
  return (
    <RegularButton data-qa={DATA_QA_PRODUCT_SET_BUTTON} aria-label={text} href={href} wide>
      {text}
    </RegularButton>
  );
};
